<script setup lang="ts">
import type { Participant } from '@/types/participant.js';
import { PAvatar, PAvatarFallback, PAvatarStack, type PAvatarVariants } from '@pokerly/ui';
import { computed } from 'vue';
import UserAvatar from '@/components/user-avatar/UserAvatar.vue';

interface Props {
    participants: Participant[];
    size?: PAvatarVariants['size'];
}

const PARTICIPANTS_WITH_FULL_DETAILS_COUNT = 6;

const props = withDefaults(defineProps<Props>(), { size: 'default' });

const firstParticipants = computed(() => {
    return props.participants.slice(0, PARTICIPANTS_WITH_FULL_DETAILS_COUNT).reverse();
});
const remainingParticipantsCount = computed((): number => {
    const value = props.participants.length - PARTICIPANTS_WITH_FULL_DETAILS_COUNT;
    return value > 0 ? value : 0;
});
</script>

<template>
    <PAvatarStack stack-order="first-on-top">
        <UserAvatar
            v-for="participant in firstParticipants"
            :key="participant.id"
            :participant="participant"
            :size="size"
            hide-badge
        />
        <PAvatar v-if="remainingParticipantsCount" :size="size">
            <PAvatarFallback>{{ remainingParticipantsCount }}+</PAvatarFallback>
        </PAvatar>
    </PAvatarStack>
</template>
